import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Demo_Pay_Route, Orders_Route, Register_Route, Reviews_Route} from '../../router/routes.js';
import api from '../../api/api.js';

function Reviews() {
    const [reviews, setReviews] = useState([]);
    const [newReview, setNewReview] = useState({text: '', img: '', author: ''});
    const [editingId, setEditingId] = useState(null);
    const [editedReview, setEditedReview] = useState({text: '', img: '', author: ''});
    const navigate = useNavigate();

    const loadReviews = async () => {
        try {
            const response = await api.get("/reviews");
            if (response.data.success && response.data.data) {
                setReviews(Array.isArray(response.data.data)
                    ? response.data.data
                    : [response.data.data]);
            } else {
                throw new Error("Invalid data format");
            }
        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    useEffect(() => {
        loadReviews();
    }, []);

    const handleAddReview = async () => {
        if (!newReview.text.trim() || !newReview.author.trim()) return;

        try {
            const response = await api.post("/reviews", newReview);
            if (response.data.success) {  // Изменили проверку здесь
                setNewReview({text: '', img: '', author: ''});
                await loadReviews();
            } else {
                throw new Error("Error adding review");
            }
        } catch (error) {
            console.error("Error adding review:", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await api.delete(`/reviews/${id}`);
            if (response.data.success) {  // И здесь
                await loadReviews();
            } else {
                throw new Error("Error deleting review");
            }
        } catch (error) {
            console.error("Error deleting review:", error);
        }
    };

    const handleSaveEdit = async (id) => {
        try {
            const response = await api.patch(`/reviews/${id}`, editedReview);
            if (response.data.success) {  // И здесь
                setEditingId(null);
                await loadReviews();
            } else {
                throw new Error("Error updating review");
            }
        } catch (error) {
            console.error("Error updating review:", error);
        }
    };


    return (
        <div className="reviews-container">
            <div className="nav-buttons">
                <button type="button" onClick={() => navigate(Orders_Route)}>Orders</button>
                <button type="button" onClick={() => navigate(Register_Route)}>Register</button>
                <button type="button" onClick={() => navigate(Demo_Pay_Route)}>Crypto Pay</button>
                <button onClick={() => window.open("https://api.pay-ichanger.world/createPayment/", "_blank")}>
                    Kassify
                </button>
            </div>

            <h2>Reviews</h2>

            <div className="reviews-form">
                <input
                    type="text"
                    placeholder="Enter review text..."
                    value={newReview.text}
                    onChange={(e) => setNewReview({...newReview, text: e.target.value})}
                />
                <input
                    type="text"
                    placeholder="Image URL (optional)"
                    value={newReview.img}
                    onChange={(e) => setNewReview({...newReview, img: e.target.value})}
                />
                <input
                    type="text"
                    placeholder="Author name"
                    value={newReview.author}
                    onChange={(e) => setNewReview({...newReview, author: e.target.value})}
                />
                <button type="button" onClick={handleAddReview}>Add Review</button>
            </div>

            <div className="reviews-list">
                {reviews.map((review) => (
                    <div key={review._id} className="review-card">
                        {editingId === review._id ? (
                            <div className="review-edit">
                                <input
                                    type="text"
                                    value={editedReview.text}
                                    onChange={(e) => setEditedReview({...editedReview, text: e.target.value})}
                                />
                                <input
                                    type="text"
                                    value={editedReview.img}
                                    onChange={(e) => setEditedReview({...editedReview, img: e.target.value})}
                                />
                                <input
                                    type="text"
                                    value={editedReview.author}
                                    onChange={(e) => setEditedReview({...editedReview, author: e.target.value})}
                                />
                                <button type="button" onClick={() => handleSaveEdit(review._id)}>Save</button>
                                <button type="button" onClick={() => setEditingId(null)}>Cancel</button>
                            </div>
                        ) : (
                            <>
                                {review.img && (
                                    <img src={review.img} alt={review.author} className="review-img"/>
                                )}
                                <p className="review-text">{review.text}</p>
                                <p className="review-author">— {review.author}</p>
                                <div className="review-actions">
                                    <button type="button" onClick={() => handleEdit(review)}>Edit</button>
                                    <button type="button" onClick={() => handleDelete(review._id)}>Delete</button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Reviews;
